import { Moment } from 'moment'

export interface LastSeenInfo {
	isOnline: boolean,
	lastSeenDate: Moment|null,
	daysSinceLastSeen: number
}